import { Box } from '@mui/material'
import { useState } from 'react'
import Swal from 'sweetalert2'
import AccountCreationForm from '../../components/AccountCreationForm/AccountCreationForm'
import { api } from '../../services/api'
import REGEX from '../../utils/regex'

function AccountCreationFormContainer() {
  const [dataForm, setDataForm] = useState([
    {
      id: 'clientName',
      element: 'input',
      type: 'text',
      label: 'Nombre y Apellido',
      value: '',
      error: '',
      regEx: REGEX.textFormatValidator,
      regMessage: 'El nombre debe contener solo letras.'
    },
    {
      id: 'clientEmail',
      element: 'input',
      type: 'email',
      label: 'Email',
      value: '',
      error: '',
      regEx: REGEX.emailFormatValidator,
      regMessage: 'El formato de email es inválido (Ej: usuario@correo.com ).'
    },
    {
      id: 'clientPassword',
      element: 'input',
      type: 'password',
      label: 'Contraseña',
      value: '',
      error: '',
      regEx: REGEX.passwordFormatValidator,
      regMessage:
        'La contraseña debe contener entre 8 y 15 caracteres, al menos 1 mayúscula, 1 minúscula, 1 número y un carácter especial.'
    },
    {
      id: 'clientPhone',
      element: 'input',
      type: 'tel',
      label: 'Teléfono',
      value: '',
      error: '',
      regEx: REGEX.phoneFormatValidator,
      regMessage:
        'El teléfono debe contener entre 8 y 11 números (sin espacios, ni guiones).'
    },
    {
      id: 'company',
      element: 'input',
      type: 'text',
      label: 'Empresa o Razón Social',
      value: '',
      error: '',
      regEx: REGEX.lettersAndNumbersValidator,
      regMessage:
        'El nombre de la empresa no puede contener caracteres especiales.'
    },
    {
      id: 'clientTipDoc',
      element: 'select',
      value: '',
      error: '',
      regEx: REGEX.docTypeValidator,
      regMessage: 'Debe seleccionar una opción'
    },
    {
      id: 'clientNroDoc',
      element: 'input',
      type: 'text',
      label: 'CUIT o Número documento',
      value: '',
      error: '',
      regEx: REGEX.cuitFormatValidator,
      regMessage:
        'El número del documento debe contener entre 7 y 11 carácteres (sin guiones ni puntos).'
    }
  ])

  function handleChange(e) {
    const newDataForm = [...dataForm]
    newDataForm.forEach((dato) => {
      if (e.target.name === dato.id) dato.value = e.target.value
    })
    setDataForm(newDataForm)
  }

  const createDataApi = (data) => {
    let formattedData = []
    formattedData = data.map((el) => {
      return [...formattedData, el.id, el.value]
    })
    return Object.fromEntries(formattedData)
  }

  const saveDataInAPI = () => {
    let error = ''
    const dataAPI = createDataApi(dataForm)
    api.account
      .registerUser(dataAPI)
      .then((data) => {
        if (data.status === 200) {
          Swal.fire({
            customClass: {
              confirmButton: 'swalBtnOk',
              title: 'swalTitle'
            },
            position: 'left',
            icon: 'success',
            title: 'Su formulario se envió con éxito',
            text: 'Gracias por registrarte. Recibiras un email con la confirmación del alta.',
            width: '350px',
            showConfirmButton: true,
            focusConfirm: false,
            iconColor: '#36A160',
            color: '#292929',
            background: '#FAFAFA',
            confirmButtonColor: 'rgb(230, 11, 19)'
          })
        }
        const newDataForm = [...dataForm]
        newDataForm.forEach((dato) => {
          dato.value = ''
        })
        setDataForm(newDataForm)
      })
      .catch((err) => (error = err))

    return error
  }

  function dataValidation() {
    let errorMessage = ''
    const newDataForm = [...dataForm]
    newDataForm.forEach((field) => {
      field.error = !field.value.toString().match(field.regEx)
        ? field.regMessage
        : ''
      errorMessage = errorMessage + field.error
    })
    setDataForm(newDataForm)

    return errorMessage
  }
  function handleSubmit(e) {
    e.preventDefault()
    let validatingError = ''
    validatingError = dataValidation()
    if (validatingError !== '') {
      return
    }
    saveDataInAPI()
  }

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) => {
          return theme.palette.primary.main
        },
        width: '100vw',
        heigth: '100vh'
      }}
    >
      <AccountCreationForm
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        dataForm={dataForm}
      />
      ;
    </Box>
  )
}

export default AccountCreationFormContainer
